// Mark bought, answered next to its button: pick the receipts already uploaded,
// or say the receipt follows.

import React, { useState } from 'react';
import AnchoredPopover from './AnchoredPopover';
import ReceiptCandidates from './ReceiptCandidates';
import { buttonClass } from '../components/ui/Button';

interface Props {
  requisitionId: string;
  busy: boolean;
  disabled: boolean;
  /** `null` means receipt to follow. Resolve true to close. */
  onConfirm: (receiptPids: string[] | null) => Promise<boolean>;
}

const MarkBoughtPopover: React.FC<Props> = ({ requisitionId, busy, disabled, onConfirm }) => {
  const [picked, setPicked] = useState<string[]>([]);

  return (
    <AnchoredPopover
      triggerLabel={busy ? 'Saving…' : 'Mark bought'}
      triggerClassName={buttonClass('filled')}
      tooltip="Marks it bought, with its receipt or with the receipt to follow"
      title="Mark this request bought"
      disabled={disabled || busy}
      width="lg"
      onOpen={() => setPicked([])}
    >
      {(close) => (
        <div className="space-y-3">
          <p className="text-xs text-on-surface-variant">
            Pick the receipt if it is already uploaded. If not, mark it bought with the receipt to follow.
          </p>
          <ReceiptCandidates requisitionId={requisitionId} selected={picked} onChange={setPicked} />
          <div className="flex flex-wrap justify-end gap-2 pt-1">
            <button
              type="button"
              disabled={busy}
              onClick={async () => {
                if (await onConfirm(null)) close();
              }}
              className={buttonClass('quiet', 'sm')}
            >
              Receipt to follow
            </button>
            <button
              type="button"
              disabled={busy || picked.length === 0}
              onClick={async () => {
                if (await onConfirm(picked)) close();
              }}
              className={buttonClass('filled', 'sm')}
            >
              {picked.length > 1 ? `Mark bought with ${picked.length} receipts` : 'Mark bought'}
            </button>
          </div>
        </div>
      )}
    </AnchoredPopover>
  );
};

export default MarkBoughtPopover;
